export default __webpack_public_path__ + "atomic/_patterns/02-molecules/plot-comparison/_plot-comparison.twig";